var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[_c('span',{staticClass:"text-body-2 my-4 pa-4 lh-175 rounded-lg",class:{ 'field-response': _vm.value }},[_vm._v(_vm._s(_vm.value))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }